var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isAdmin)?_c('CurrentOrdersTableAdmin',{on:{"showMore":_vm.showMore,"reload":_vm.reload,"selectAll":_vm.selectAll}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }